module.exports = __webpack_public_path__ + "img/dropdown.ed79e10a.svg";